import {IAppliedRule} from '../incase-domain/appliedRules';
import {testShouldBlock} from '../service/rule.service';
import {ISlide} from '../incase-domain/slide';
import {ElementInteraction, IRunFile} from '../incase-domain/proptypes/runfile';
import {IElement} from '../incase-domain/elements';
import {interactiveElementTypes} from '../incase-domain/elements/base/ElementTypes';
import {IRoomRunFile} from '../incase-domain/proptypes/IRoomRunFile';
import {IFetchRoom} from '../incase-domain/rooms/room.player';

function isBlockedByRules(appliedRules: IAppliedRule[] | undefined, slideId: string): boolean {
    return !!appliedRules?.some((rule): boolean => testShouldBlock(rule, slideId));
}

export function hasUnansweredBlockedElements(slide: ISlide, runFile: IRunFile): boolean {
    const blockingElements = (slide.elements || [])
        .filter((element) => interactiveElementTypes.includes(element.type))
        .filter((element) => (element as IElement & {blockingQuestion: boolean}).blockingQuestion);

    return blockingElements.some((element): boolean => {
        const elInteraction =
            runFile.elementInteractions &&
            runFile.elementInteractions[element.slideId] &&
            runFile.elementInteractions[element.slideId][element.id];

        if (!elInteraction) {
            return true;
        }

        return !(elInteraction as ElementInteraction & {answered: boolean}).answered;
    });
}

export function checkIfBlockedInRoom(room: IFetchRoom, roomRunFile: IRoomRunFile, newSlideIndex: number): boolean {
    if (room.isPresenter) return false;
    return newSlideIndex > roomRunFile.ownerCurrentSlideIndex;
}

export function checkShouldBlock(
    appliedRules: IAppliedRule[] | undefined,
    slide: ISlide,
    runFile: IRunFile,
    room: IFetchRoom,
    roomRunFile: IRoomRunFile,
    newSlideIndex: number,
    lastShownSlideIndex: number,
    currentSlideIndex: number
): boolean {
    const isRoom = !!room.roomId && !!roomRunFile._id;
    if (isRoom) return checkIfBlockedInRoom(room, roomRunFile, newSlideIndex);
    if (newSlideIndex <= currentSlideIndex) return false;
    return isBlockedByRules(appliedRules, slide._id) || hasUnansweredBlockedElements(slide, runFile);
}
